import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { SelectItemsProp } from 'miljodir-wc/dist/src/index';

const testTooltip = `
1914 translation by H. Rackham
"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?"

Section 1.10.33 of "de Finibus Bonorum et Malorum", written by Cicero in 45 BC
"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."
`;

const initTestSelectData: SelectItemsProp[] = [
  { key: '1', text: 'Peas' },
  { key: '2', text: 'Carrots' },
  { key: '3', text: 'Tomatoes' },
  { key: '4', text: 'Brussel sprouts' },
  { key: '5', text: 'Cabbages' },
  { key: '6', text: 'Cauliflower' },
  { key: '7', text: 'Cucumber' },
  { key: '8', text: 'Chili' },
  { key: '9', text: 'Garlic' },
  { key: '10', text: 'Eggplant' },
  { key: '11', text: 'Leeks' },
  { key: '12', text: 'Onions' }
];

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent {

  tooltipText = testTooltip;
  testSelectData = initTestSelectData;
  selectStatus: 'Idle' | 'Loading' = 'Idle';

  labelUnsafe = 'Works with richtext: <a href=\'https://www.vg.no\'>Vg link</a>';
  showTooltip = false;

  valueNgModel = 'ngModel';

  form = new FormGroup({
    firstName: new FormControl('bob', [Validators.required, forbiddenNameValidator(/bob/i)]),
    lastName: new FormControl('', [Validators.required, forbiddenNameValidator(/bob/i)]),
    customTooltip: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required, forbiddenNameValidator(/bob/i)]),
    gender: new FormControl('Male', [Validators.required]),
    checkIt: new FormControl(false),
    checkItToo: new FormControl(false),
    vegetable: new FormControl([] as SelectItemsProp[]),
    singleExample: new FormControl(null)
  });

  onTooltipToggle(_: Event) {
    this.showTooltip = !this.showTooltip;
  }

  logChange(ev: CustomEvent) {
    this.selectStatus = 'Loading';
    setTimeout(() => {
      this.testSelectData = initTestSelectData.filter(x => x.text.trim().toLowerCase().includes(ev.detail.value.trim().toLowerCase()));
      this.selectStatus = 'Idle';

    }, 1000);
    console.log('Debug event from angular', ev.detail.value, this.testSelectData);
  }

  handleClick(ev: Event) {
    console.log('Debug angular click event', ev);
    if (this.form.valid) {
      alert(`API-POST:  ${JSON.stringify(this.form.value)}`);
    }
    else {
      const result = {
        firstName: { value: this.form.controls['firstName'].value, valid: this.form.controls['firstName'].valid, errors: this.form.controls['firstName'].errors },
        lastName: { value: this.form.controls['lastName'].value, valid: this.form.controls['lastName'].valid, errors: this.form.controls['lastName'].errors }
      };
      alert(`API-POST:  ${JSON.stringify(result)}`);
    }
  }

}

function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = nameRe.test(control.value);
    return forbidden ? { forbiddenName: { value: control.value } } : null;
  };
}
